/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerPlugDiagIcon16Solid = forwardRef('TechPowerPlugDiagIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.889.576a1 1 0 0 1 0 1.414L9.591 4.288l2.121 2.121 2.298-2.298a1 1 0 1 1 1.415 1.414l-2.299 2.298.884.884a1 1 0 0 1 0 1.414l-1.59 1.591a5.752 5.752 0 0 1-7.152.788L2.166 15.6a1.25 1.25 0 0 1-1.768-1.767L3.5 10.732a5.752 5.752 0 0 1 .788-7.151l1.59-1.591a1 1 0 0 1 1.415 0l.884.884L10.475.576a1 1 0 0 1 1.414 0Z" })));
});
